import $ from "jquery";

const config = {
  selectors: {
    accordionContainer: '.js-accordion',
    accordionTrigger: '.js-accordion-trigger',
    accordionToggle: '.js-accordion-toggle',
    accordionTabTrigger: '.js-accordion-tab-trigger',
    accordionTabPanel: '.js-accordion-tab-panel',
    accordionExpand: '.js-accordion-expand',
    accordionCollapse: '.js-accordion-collapse'
  },
  modifiers: {
    isActive: 'accordion--expand'
  }
};

const Accordion = () => {
  $(config.selectors.accordionTrigger).on('click', function(){
    if (!($(this).hasClass(config.modifiers.isActive))) {
      $(config.selectors.accordionContainer).children().removeClass(config.modifiers.isActive);
    }
    $(this).toggleClass(config.modifiers.isActive);
    $(this).next(config.selectors.accordionToggle).toggleClass(config.modifiers.isActive);
  });

  $(config.selectors.accordionTabTrigger).on('click', function() {
    const target = $($(this).data('target'));
    const tabTitle = $(this).filter('[data-target="' + $(this).data('target') + '"]');
    $(config.selectors.accordionTabTrigger).removeClass(config.modifiers.isActive).parent().find(tabTitle).addClass(config.modifiers.isActive);
    $(config.selectors.accordionTabPanel).children().removeClass(config.modifiers.isActive).parent().find(target).addClass(config.modifiers.isActive);
  });

  $(config.selectors.accordionExpand).on('click', function() {
    $(this).parents(config.selectors.accordionContainer).toggleClass(config.modifiers.isActive);
    $(this).parents(config.selectors.accordionContainer).find(config.selectors.accordionToggle).toggleClass(config.modifiers.isActive);
  });

  $(config.selectors.accordionCollapse).on('click', function() {
    $(this).parents(config.selectors.accordionContainer).toggleClass(config.modifiers.isActive);
    $(this).parents(config.selectors.accordionToggle).prev().toggleClass(config.modifiers.isActive);
    $(this).parents(config.selectors.accordionToggle).toggleClass(config.modifiers.isActive);
  })
};

export default Accordion;
